module.exports = __webpack_public_path__ + "media/src/images/addtoprofilebutton_fr-a412c321a4448777533195b02584a3eb.png";